import React, { useState } from "react";
import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import Mylogo from "../../photos/trademark.png";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, LOGIN } from "../services/end_points";
import { _post } from "../services/service_api";
import {
  UserOutlined,
  KeyOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
const Login = () => {
  const navigate = useNavigate();
  // const [formdata, setFormdata] = useState({
  //   email: "",
  //   password: "",
  // });
  const [alert, setAlert] = useState(null);

  const handleSubmit = async (formdata) => {
    // Check for empty email or password
    if (!formdata.password || !formdata.email) {
      setAlert("Email and password are required");
      return;
    }

    try {
      const response = await _post(`${API_BASE_URL}${LOGIN}`, formdata);
      if (response.data.message === "Welcome to Dr_appt") {
        const { token, userId, userName, roleId } = response.data.response;

        // Store user data in localStorage
        localStorage.setItem("token", token);
        localStorage.setItem("userid", userId);
        localStorage.setItem("username", userName);
        localStorage.setItem("userType", roleId);

        // Navigate to dashboard
        navigate("/dashboard");
        window.location.reload();
      } else {
        setAlert(response.data.message);
      }
    } catch (error) {
      // Set error message
      if (error.response?.data?.message) {
        setAlert(error.response.data.message);
      } else {
        setAlert("An error occurred. Please try again.");
      }
      console.error("Error logging in:", error);
    }
  };

  return (
    <Row justify="center" align="middle" style={{ minHeight: "100vh" }}>
      <Col>
        <Card
          style={{
            width: 300,
            textAlign: "center",
            boxShadow: "0px 4px 8px #6499f1",
          }}
        >
          <img src={Mylogo} alt="Logo" style={{ width: "150px" }} />
          <Form
            onFinish={handleSubmit} // Use onFinish to handle submission
            layout="vertical"
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Enter a valid email address!" },
              ]}
              style={{ marginBottom: 10 }}
            >
              <Input
                type="email"
                placeholder="Your email address"
                size="large"
                prefix={<UserOutlined />}
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please enter your password!" },
              ]}
              style={{ marginBottom: 10 }}
            >
              <Input.Password
                placeholder="Your password"
                size="large"
                prefix={<KeyOutlined />}
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            {alert && (
              <Typography.Text type="danger" style={{ padding: "10px" }}>
                {alert}
              </Typography.Text>
            )}

            <Button
              type="primary"
              htmlType="submit"
              style={{
                backgroundColor: "#6499f1",
                fontSize: "16px",
                color: "white",
                marginTop: "1.5rem",
                borderRadius: "10px",
                width: "100%",
                height: "2.5rem",
              }}
            >
              Submit
            </Button>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default Login;
